import { Apple, HomeOutlined, StoreOutlined } from '@mui/icons-material';
import { Page } from '@/api/common/common.types.ts';
import { useTranslation } from 'react-i18next';

export function useCustomerPages(): Page[] {
  const { t } = useTranslation('common');

  return [
    {
      title: t('nav.home'),
      url: '/bp/c',
      icon: <HomeOutlined />,
    },
    { title: t('nav.shop'), url: '/bp/c/items', icon: <StoreOutlined /> },
    {
      title: t('nav.ctoFinder'),
      url: '/bp/c/cto',
      icon: <Apple />,
    },
  ];
}
